export default __webpack_public_path__ + "static/media/taskmaster-iphone.c8aaf4bd.png";